import { store } from "@bluemodus/blue-search";
import { cloneDeep } from "lodash-es";

const state = {
	...store.state,
	activeSearchTerm: null,
	suggestions: [],
};
const getters = {
	...store.getters,
	activeSearchTerm: state => state.activeSearchTerm,
	suggestions: state => state.suggestions,
};
const mutations = {
	...store.mutations,
	setStateValue(state, payload) {
		if (typeof payload[1] == "object") {
			let newObj = cloneDeep(payload[1]);
			state[payload[0]] = newObj;
		} else {
			state[payload[0]] = payload[1];
		}
	},
};
const actions = {
	...store.actions,
	getSuggestions({state, commit}, endpoint) {
		if (state.activeSearchTerm.length < 3 || !endpoint) {
			return Promise.resolve();
		}

		return new Promise(async resolve => {
			const request = await fetch(endpoint, {
				method: 'POST',
				mode: 'cors',
				cache: 'no-cache',
				credentials: 'same-origin',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					term: state.activeSearchTerm,
				}),
			});

			if (request.ok) {
				const results = await request.json();
				commit('setStateValue', ['suggestions', results]);
			} else {
				const error = await request.json();
			}
			resolve();
		});
	},
};

export default {
	state,
	getters,
	mutations,
	actions
};